'use strict';

module.exports = function(Product) {
   
   
    Product.getWithPriceForEvent = async function(eventId){
        let products = await Product.find( { where: { eventId:eventId },
            // include:['memberInfos','teamInfos']        
            include:[{relation: 'memberInfos',
            scope: { // fetch 1st "page" with 5 entries in it
              skip:0,
              order:'order ASC'
            }},'teamInfos']        
        } )
        let productsFinal = [];
        for (let i = 0; i < products.length; i++) {
            let product = products[i];
            product.currentPriceObj = getPrice(product);
            product.currentPrice =  product.currentPriceObj.price;
            product.price = product.currentPriceObj.price;
            product = product.toJSON();
            productsFinal.push(product)
        }
        return productsFinal
    }
    

    function getPrice(product){
            let prices = product.prices || [];
            let currentPrice = 0;
            let date = new Date();
            for (let i = 0; i < prices.length; i++) {
                const priceObj = prices[i];
                if( date >= new Date(priceObj.date) ){
                    currentPrice = priceObj;
                }
            }
            return currentPrice;
    }

};
